import React from 'react';
import { Container, Col, Row, ListGroup, Button, Modal } from 'react-bootstrap';
import { FaRedo } from 'react-icons/fa'

import { IntrashBackend } from './backend';

import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';


export class LoggedInUsersPage extends React.Component {
    constructor(props) {
        super(props);
  
        this.state = {
            loggedInUsers: []
        };

        this.refreshUsers();
    }

    async refreshUsers() {
        const users = await IntrashBackend.getLoggedInUsers();
        users.sort((a, b) => a.timestamp > b.timestamp ? -1 : 1);
        this.setState({ loggedInUsers: users });
    }

    elapsedSecondsToString(es) {
        if (es < 60) {
            return "seconds ago";
        }
        //else
        var s = ""
        var t = es;
        if (t >= 86400) {
            const days = Math.floor(t / 86400);
            if (days === 1) { s += "1 day "; }
            else { s += days + " days "; }
            t -= days * 86400;
        }
        if (t >= 3600) {
            const hours = Math.floor(t / 3600);
            if (hours === 1) { s += "1 hour "; }
            else { s += hours + " hours "; }
            t -= hours * 3600;
        }
        if (t >= 60) {
            const minutes = Math.floor(t / 60);
            if (minutes === 1) { s += "1 minute "; }
            else { s += minutes + " minutes "; }
            t -= minutes * 60;
        }
        return s + "ago";
    }

    mapUserToListItem = (u) => {
        const user = u.user;
        const elapsed = this.elapsedSecondsToString(u.elapsedSeconds);
        const foreColor = u.elapsedSeconds < (10 * 60) ? "black" : "gray";
        return (
            <ListGroup.Item style={{ overflow: "hidden" }} key={user.id}>
                <Row className="my-auto">
                    <Col className="my-auto text-left" as="h5" style={{ color: foreColor }}>
                        {user.username}
                    </Col>
                    <Col className="my-auto text-left" xs="auto" md="auto" as="h6" style={{ color: foreColor }}>
                        {elapsed}
                    </Col>
                </Row>
            </ListGroup.Item>
        );
    }
    
    renderUsersList = () => {
        if (this.state.loggedInUsers) {
            return (
                <>
                    <ListGroup>
                        {this.state.loggedInUsers.map(this.mapUserToListItem)}
                    </ListGroup>
                </>
            );
        }
    }

    render() {
        return (
            <>
                <Container fluid>
                    <Row>
                        <Col><Button variant="link" style={{ color: "gray" }} onClick={ () => this.refreshUsers() }><FaRedo/></Button></Col>
                        <Col xs="auto"><h3 className="text-center">Sessions</h3></Col>
                        <Col/>
                    </Row>
                    <br/>
                    {this.renderUsersList()}
                </Container>
                <Modal show={this.state.showErrorModal} onHide={() => this.setState({ showErrorModal: false })}>
                    <Modal.Header closeButton>
                        <Modal.Title>Error</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{this.state.errorModalText}</Modal.Body>
                    <Modal.Footer>
                        <Button onClick={() => this.setState({ showErrorModal: false })}>
                            OK
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}